import { Breadcrumbs, Grid, Link, Typography } from "@mui/material"
import TopSideBar from "../../components/TopSideBar"
import PageContainer from "../../components/common/PageContainer"
import TitlebarAction from "../../components/common/TitlebarActions"
import { PADDING_BASE } from "../../assets/Styles"
import UsersManagement from "../../components/UsersManagement"
import Copyright from "../../components/common/Copyright"

export default function UsersManagementPage({ setBlockScreen }: any) {
  return (<>
    <TopSideBar currentSection='users' hideProjectSelector />

    <PageContainer>

      <Grid paddingBottom={PADDING_BASE}>
        <Breadcrumbs aria-label="breadcrumb">
          <Link underline="hover" color="darkgreen" href="/tickets/listing">
            Home
          </Link>
          <Typography color="darkgreen" fontFamily="Poppins" fontWeight="400">
            Gestión de Usuarios
          </Typography>
          <Typography color="darkgreen" fontFamily="Poppins" fontWeight="600">
            Usuarios
          </Typography>
        </Breadcrumbs>
      </Grid>

      <TitlebarAction title='Administrar Usuarios' />

      <UsersManagement setBlockScreen={setBlockScreen} />

      <Copyright />

    </PageContainer>
  </>)
}